module.exports = __webpack_public_path__ + "fonts/Vonnes-BookCond.4c31feab.otf";